import React from 'react';
import { NavLink } from 'react-router-dom';

import money from './../../../../assets/images/svg/109-money.svg';
import archives from './../../../../assets/images/svg/111-archives.svg';

export const Header = () => {
	return (
		<div className="container-fluid">
			{/* <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4 mb-gd-sm">
				<h2 className="sr-only visually-hidden">Settings: Status</h2>
				<div className="grid grid-sm-narrow grid-xl-4">
					<div className="card rounded shadow">
						<div className="card-body media p-2">
							<div className="rounded-max bg-common d-inherit mr-3 rounded-progress text-center">
								<img className="img-fluid m-auto my-3 mb-2 py-1" src={money} alt="money" />
							</div>
							<div className="media-body my-auto text-truncate">
								<h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Paiement</h3>
								<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">Fait</p>
							</div>
						</div>
					</div>
					<div className="card rounded shadow">
						<div className="card-body media p-2">
							<div className="rounded-max bg-common d-inherit mr-3 rounded-progress text-center">
								<img className="img-fluid m-auto my-3 mb-2 py-1" src={archives} alt="archives" />
							</div>
							<div className="media-body my-auto text-truncate">
								<h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">besoin d'alerte</h3>
								<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">0 documents</p>
							</div>
						</div>
					</div>
				</div>
			</header> */}
			<nav className="navbar navbar-expand-md navbar-light px-0 mb-2">
				<h1 className="sr-only visually-hidden">Settings: navigation</h1>
				<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
					<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
				</button>
				<div className="collapse navbar-collapse flex-column" id="navbarNav">
					<hr className="d-md-none" />
					<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
						<NavLink exact to="/anticipa/settings" activeClassName="active" className="nav-item text-uppercase rounded-inherit ml-lg-0 w-auto flex-lg-grow-1">
							<div className="nav-link py-1 px-0">Profil<span className="d-sm-none d-xl-inline-block ml-1"> de l'utilisateur</span></div>
						</NavLink>
						<NavLink exact to="/anticipa/settings/securite" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Sécurité</div>
						</NavLink>
						<NavLink exact to="/anticipa/settings/paiement" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Méthodes<span className="d-sm-none d-xl-inline-block ml-1"> de paiement</span> </div>
						</NavLink>
						<NavLink exact to="/anticipa/settings/facturation" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Facturation</div>
						</NavLink>
						<NavLink exact to="/legal/terms" activeClassName="active"  target="_blank" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Mentions Légales</div>
						</NavLink>
					</ul>
					<hr className="d-md-none mb-0" />
				</div>
			</nav>
		</div>
	)
}